export var HDREncodeFormat;
(function (HDREncodeFormat) {
    HDREncodeFormat[HDREncodeFormat["NONE"] = 0] = "NONE";
    HDREncodeFormat[HDREncodeFormat["RGBM"] = 1] = "RGBM";
    HDREncodeFormat[HDREncodeFormat["RGBD"] = 2] = "RGBD";
})(HDREncodeFormat || (HDREncodeFormat = {}));
